import React, { useEffect } from 'react';
import './RequestService.css';

const RequestService = () => {
  useEffect(() => {
    // Dynamically load the Jotform embed handler
    if (!document.querySelector("script[src='https://cdn.jotfor.ms/s/umd/latest/for-form-embed-handler.js']")) {
      const script = document.createElement('script');
      script.src = 'https://cdn.jotfor.ms/s/umd/latest/for-form-embed-handler.js';
      script.async = true;
      script.onload = () => {
        if (window.jotformEmbedHandler) {
          window.jotformEmbedHandler(
            "iframe[id='JotFormIFrame-252755044813154']",
            "https://form.jotform.com/"
          );
        }
      };
      document.body.appendChild(script);
    }
  }, []);

  return (
    <section className="request-section" id="request-service">
      <div className="request-content">
        <h2 className="request-title">Request a Cleaning Service</h2>
        <p className="request-subtitle">
          Fill out the form below and we’ll get back to you as soon as possible.
        </p>

        {/* JotForm iframe */}
        <iframe
          id="JotFormIFrame-252755044813154"
          title="House Cleaning Service Quote Request"
          src="https://form.jotform.com/252755044813154"
          frameBorder="0"
          style={{
            minWidth: '100%',
            maxWidth: '100%',
            height: '539px',
            border: 'none'
          }}
        />
      </div>
    </section>
  );
};

export default RequestService;
